export default __webpack_public_path__ + "content/media/28.5e767a5c.jpg";